(() => {
  const SELECTOR = '[data-rp-product-comparison]';

  if (window.RemediuProductComparisonManager) {
    window.RemediuProductComparisonManager.mountWithin();
    return;
  }

  window.RemediuProductComparisonLoaded = true;
  const instances = new WeakMap();

  class RemediuProductComparison {
    constructor(root) {
      this.root = root;
      this.tabs = [...root.querySelectorAll('[data-rp-comparison-tab]')];
      this.panels = [...root.querySelectorAll('[data-rp-comparison-panel]')];
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onClick);
        tab.addEventListener('keydown', this.onKeydown);
      });
      this.activate(0);
    }

    onClick(event) {
      this.activate(Number.parseInt(event.currentTarget.dataset.comparisonIndex, 10));
    }

    onKeydown(event) {
      const currentIndex = Number.parseInt(event.currentTarget.dataset.comparisonIndex, 10);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === currentIndex) return;

      event.preventDefault();
      this.activate(nextIndex, true);
    }

    activate(index, focus = false) {
      if (!this.tabs[index]) return;

      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.classList.toggle('rp-product-comparison__tab--active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });

      this.panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index;
      });

      if (focus) this.tabs[index].focus();
    }

    destroy() {
      this.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.onClick);
        tab.removeEventListener('keydown', this.onKeydown);
      });
    }
  }

  const mount = (root) => {
    if (!root || instances.has(root)) return;
    instances.set(root, new RemediuProductComparison(root));
  };

  const unmount = (root) => {
    const instance = instances.get(root);
    if (!instance) return;
    instance.destroy();
    instances.delete(root);
  };

  const mountWithin = (container = document) => {
    if (container.matches?.(SELECTOR)) mount(container);
    container.querySelectorAll?.(SELECTOR).forEach(mount);
  };

  window.RemediuProductComparison = RemediuProductComparison;
  window.RemediuProductComparisonManager = { mountWithin, unmount };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountWithin());
  } else {
    mountWithin();
  }

  document.addEventListener('shopify:section:load', (event) => mountWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.(SELECTOR)
      ? event.target
      : event.target.querySelector?.(SELECTOR);
    unmount(root);
  });
})();
